export var startingFreshContent = {
    steps: [
        {
            title: 'Ready',
            description: 'Tell us aaaall about your dog. It helps us recommend a meal plan customized for their nutritional requirements and taste preferences.',
            stepNumber: 1,
        },
        {
            title: 'Set',
            description: 'Our team prepares and portions your pup’s meals in our Nashville kitchens, according to their unique caloric needs.',
            stepNumber: 2,
        },
        {
            title: 'Nom',
            description: 'Gently cooked food is delivered to your door based on a schedule you set. Your dog does the dinnertime happy dance.',
            stepNumber: 3,
        },
    ],
    ctaUrl: '/how-it-works',
    buttonLabel: 'How It Works',
};
